import type { ReactNode } from 'react';

export const symbol_cinematic_blur: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m140-840 58 119q7.73 15.4 22.08 24.2Q234.44-688 251-688q32.5 0 49.25-27.46T303-772l-33-68h89l58 119q7.73 15.4 22.08 24.2Q453.44-688 470-688q32.5 0 49.25-27.46T522-772l-33-68h89l58 119q7.73 15.4 22.08 24.2Q672.44-688 689-688q32.5 0 49.25-27.46T741-772l-33-68h112q24 0 42 18t18 42v600q0 24-18 42t-42 18H140q-24 0-42-18t-18-42v-600q0-24 18-42t42-18Zm0 212v448h680v-448H140Zm0 0v448-448Zm203 388h274q9.52 0 16.26-6.47Q640-252.94 640-263q-1-24-12-43.5T598-337q-22-12-49.5-17.5t-68-5.5q-40.5 0-68 5.5T363-336.62Q343-326 332-306.5T320-263q0 10.06 6.5 16.53Q333-240 343-240Zm189.5-201.5Q554-463 554-494t-21.5-52.5Q511-568 480-568t-52.5 21.5Q406-525 406-494t21.5 52.5Q449-420 480-420t52.5-21.5Z"
		/>
	</svg>
);
